module.exports = __webpack_public_path__ + "src/assets/video/howToPlayLayEgg.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/howToPlayLayEgg.gif
// module id = ./src/assets/video/howToPlayLayEgg.gif
// module chunks = 0